import { RouteSectionProps } from "@solidjs/router";

import { PageLayout } from "#root/layouts/PageLayout";
import { SEO } from "#root/components/SEO";
import { useTranslation } from "#root/domain/i18n";

export default function PrivacyLayout(props: RouteSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      <SEO title={t("privacy.title")} />
      <PageLayout>{props.children}</PageLayout>
    </>
  );
}
